/**
 * All Indian states & union territories — used for Branch → State mapping.
 * PT slabs may exist only for some of these in Statutory Rates; others yield ₹0 PT until configured.
 */
export const INDIAN_STATES = [
  "Andaman and Nicobar Islands",
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chandigarh",
  "Chhattisgarh",
  "Dadra and Nagar Haveli and Daman and Diu",
  "Delhi",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jammu and Kashmir",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Ladakh",
  "Lakshadweep",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Puducherry",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
];

/** @deprecated Use INDIAN_STATES — kept for existing imports */
export const PT_STATES = INDIAN_STATES;

/** Resolve PT state from employee branch (branch.state or branches list lookup).
 * Work State is not a separate employee field — Branch → State is the jurisdiction.
 */
export function resolvePtStateFromEmployee(employee = {}, branches = []) {
  const direct =
    employee?.branch?.state ||
    employee?.Branch?.state ||
    employee?.branchState ||
    null;
  if (direct && INDIAN_STATES.includes(direct)) return direct;

  const branchId = employee?.branchId ?? employee?.branch_id;
  if (branchId != null && Array.isArray(branches) && branches.length) {
    const branch = branches.find(
      (b) => String(b.id) === String(branchId) || String(b.branchId) === String(branchId)
    );
    const state = branch?.state;
    if (state && INDIAN_STATES.includes(state)) return state;
  }

  return null;
}

export default INDIAN_STATES;
